export function groupActionsByHierarchy(
  userActions = [],
  loggedInUserId, // 04 Feb 2026

) {

// First Created - 09 Sep 2025
// Author - Atul Pandey
// Purpose - Group user actions by focus → vision → mission → goal → goalPeriod → actionType
// Fallback - Group unlinked actions (no selectedFocus) under "Induction" by actionTypeName
// Updated - 10 Sep 2025 - refined the logic with actual fields of UserMissionGoal, UserMissionGoalShared and UserVision<Focus>Ids, UserMission<Focus>Ids
// Updated - 11 Sep 2025 - refined the logic for visionName, missionName, goalName and goalPeriod
// Updated - 04 Feb 2026 - refined to compute self actual value for performance display

// console.log("incoming user actions in groupActionsByHierarchy function....")
// console.log(userActions)

// 04 Feb 2026
const getSelfActualFromActions = (actions = [], loggedInUserId) => {
  return actions
    .filter(a => String(a.userId?._id) === String(loggedInUserId))
    .reduce((sum, a) => sum + (Number(a.actualValue) || 0), 0);
};
  

const grouped = {
    MyMissions: {},
    Induction: {},
  };

  // 04 Jan 2026 - DEBUG
  // console.log('inside groupActionsByHierarchy - incoming userActions', userActions)

  userActions.forEach((action) => {
   
    const focus = action.selectedFocus;
    // console.log('focus', focus)

    // 🟢 Determine top-level group (MyMissions or Induction)
    const trailName = action.trailId?.trailName;
    const topLevelGroup = trailName === "MyMissions" ? "MyMissions" : "Induction";

    // 🔴 Fallback for unlinked actions (no selectedFocus) → Directly group by actionType
    if (!focus) {
        // console.log("Fallback triggered for action: ", action);
      const actionType = action?.actionTypeId?.actionTypeName || "Unknown";
      if (!grouped[topLevelGroup][actionType]) grouped[topLevelGroup][actionType] = [];
      grouped[topLevelGroup][actionType].push(action);
      return;
    }

    // 🟢 Structured Path for focused actions
    const focusKey = focus;
    const path = [focusKey];

    // ✅ Extract visionId correctly
    const visionName =
      action.actionVisionSelfIds?.[0]?.visionId?.visionName ||
      action.actionVisionClientIds?.[0]?.visionId?.sharedVisionId?.visionName ||
      action.actionVisionOrgIds?.[0]?.visionId?.sharedVisionId?.visionName ||
      action.actionVisionTeamIds?.[0]?.visionId?.visionName ||
      action.actionVisionPartnerIds?.[0]?.visionId?.sharedVisionId?.visionName;

    // ✅ Extract missionId correctly
    const missionName =
      action.actionMissionSelfIds?.[0]?.missionId?.missionName ||
      action.actionMissionClientIds?.[0]?.missionId?.sharedMissionId?.missionName ||
      action.actionMissionOrgIds?.[0]?.missionId?.sharedMissionId?.missionName ||
      action.actionMissionTeamIds?.[0]?.missionId?.missionName ||
      action.actionMissionPartnerIds?.[0]?.missionId?.sharedMissionId?.missionName;

    // Resolve goalName
    let goalName = ""
    
    if (focus === "Self" || focus === "Team") {
        goalName = action?.connectedMissionGoals?.[0]?.connectedMissionGoalId?.goalName
    } else {
        goalName = action?.connectedMissionGoals?.[0]?.connectedSharedGoalId?.goalName
    }

    // ✅ Derive goalPeriod from connectedGoalBreakdownId inside the goal object
    let goalPeriod = null;
    const connectedGoalBreakdownId = action?.connectedMissionGoals?.[0]?.connectedGoalBreakdownId;

    if (connectedGoalBreakdownId) {
    if (focus === "Self" || focus === "Team") {
        const breakdowns = action?.connectedMissionGoals?.[0]?.connectedMissionGoalId?.goalBreakdown || [];
        const matchedBreakdown = breakdowns.find(bd =>
        String(bd._id) === String(connectedGoalBreakdownId)
        );
        goalPeriod = matchedBreakdown?.period || null;
    } else {
        const breakdowns = action?.connectedMissionGoals?.[0]?.connectedSharedGoalId?.goalBreakdown || [];
        const matchedBreakdown = breakdowns.find(bd =>
        String(bd._id) === String(connectedGoalBreakdownId)
        );
        goalPeriod = matchedBreakdown?.period || null;
    }
    }

    // Build ActionType
    const actionType = action?.actionTypeId?.actionTypeName || "Unknown";

    // console.log("🔍 Vision NAME:", visionName);
    // console.log("🔍 Mission NAME:", missionName);
    // console.log("🔍 Goal NAME:", goalName);
    // console.log("🔍 actionType:", actionType);

    // ✅ Build the structured path
    if (visionName) path.push(visionName);
    if (missionName) path.push(missionName);
    if (goalName) path.push(goalName);
    if (goalPeriod) path.push(goalPeriod);

    path.push(actionType);

    // ✅ Traverse and insert
    let current = grouped[topLevelGroup];
    for (let i = 0; i < path.length; i++) {
      const key = path[i];
      const isLast = i === path.length - 1;

      if (!current[key]) {
        current[key] = isLast ? [] : {};
      }

      if (isLast) {
        current[key].push(action);
      } else {
        current = current[key];
      }
    }
  });

  // 04 Feb 2026
  const computeSelfActualRecursive = (node, loggedInUserId) => {
    if (Array.isArray(node)) {
      return getSelfActualFromActions(node, loggedInUserId);
    }

    if (typeof node !== 'object' || node === null) return 0;

    let sum = 0;

    Object.keys(node).forEach(key => {
      if (key === '__meta') return;
      sum += computeSelfActualRecursive(node[key], loggedInUserId);
    });

    Object.defineProperty(node, '__meta', {
      value: { selfActual: sum },
      enumerable: false,   // 🔑 this is the key
      writable: true,
    });

    // node.__meta = node.__meta || {};
    // node.__meta.selfActual = sum;

    return sum;
  };

  // 🔁 compute once at root
  computeSelfActualRecursive(grouped, loggedInUserId);


  return grouped;
}